"use client";

import React from "react";
import { ArrowRight, HardHat, Zap, Map, Scissors } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  icon: HardHat,
  title: "Veteran Owned",
  description: "Owned and operated by Steve Schaefer, bringing discipline and integrity to every repair."
}, {
  icon: Zap,
  title: "24/7 Emergency",
  description: "Available round-the-clock for urgent garage door repairs and same-day service calls."
}, {
  icon: Map,
  title: "Local Service",
  description: "Proudly serving Splendora, Kingwood, New Caney, Roman Forest, Porter, Cleveland, Humble, and surrounding TX communities."
}, {
  icon: Scissors,
  title: "Free Estimates",
  description: "Transparent pricing and expert advice for custom installations, residential and commercial projects, and all repairs."
}];
export default function Hero() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll();
  return <section data-section-id="18936" id="hero" className="dark bg-background text-foreground relative min-h-[85vh] flex items-center justify-center overflow-hidden py-24">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1607942/img/modern_industrial_garage_hero.png)] bg-cover bg-center opacity-30 mix-blend-overlay" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/80 to-background" />
        <div className="absolute inset-0 !text-[hsl(0,0%,100%)] !bg-[hsl(0,0%,100%)]" />
      </div>

      <div ref={contentRef} className="relative z-10 container max-w-6xl mx-auto transition-all duration-1000 transform translate-y-0 !shadow-[0px_12px_24px_rgba(20,21,31,0.26),_0px_6px_12px_rgba(20,21,31,0.18)] !text-[hsl(210,17%,98%)] !opacity-[1] !bg-[hsl(141,84%,93%)] ![padding:20px_24px_0px_24px]">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto mb-16">
          <div className="inline-flex items-center gap-3 px-5 py-2 mb-8 rounded-full border border-primary/20 backdrop-blur-md !bg-[hsl(137,66%,31%)] !text-[hsl(0,0%,100%)]">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 !text-[hsl(0,0%,100%)] !bg-[hsl(0,0%,100%)]"></span>
            </span>
            <span className="text-xs font-semibold tracking-widest uppercase font-sans !text-[hsl(0,0%,100%)] md:text-sm">
              Veteran Owned • Locally Operated • 24/7 Service
            </span>
          </div>

          <h1 className="font-bold tracking-tighter mb-8 uppercase leading-none !font-sans !text-[hsl(137,66%,31%)] !text-[49px]">PROFESSIONAL GARAGE SERVICES</h1>

          <p className="max-w-2xl mx-auto mb-10 leading-relaxed font-sans !text-[hsl(210,9%,31%)]">From emergency repairs to precision custom installations. Veteran-owned and operated with same-day support across Kingwood, TX and surrounding areas.</p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 w-full">
            <Button asChild size="lg" className="bg-[#1B8439] text-white hover:bg-[#166C2F] rounded-xl px-6 py-3 font-semibold transition-all duration-300">
              <Link to="https://schaefergaragedoors.com/contact-us/">
                Request a Free Quote
                <ArrowRight />
              </Link>
            </Button>
            
            <Button asChild variant="secondary" size="lg" className="bg-[#1B8439] text-white hover:bg-[#166C2F] rounded-xl px-6 py-3 font-semibold transition-all duration-300">
              
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
          {features.map((feature, i) => <div key={i} data-index={i} className="p-6 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm transition-all duration-300 hover:border-primary/50 group">
              <feature.icon className="w-10 h-10 text-primary mb-4 transition-transform duration-300 group-hover:scale-110" />
              <h3 className="text-lg font-bold mb-2 font-sans uppercase tracking-tight !text-[hsl(137,66%,31%)]">
                {feature.title}
              </h3>
              <p className="text-sm leading-relaxed !text-[hsl(210,9%,31%)] !border-1 border-solid !border-transparent border-[hsl(208,7%,46%)]">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent z-10 pointer-events-none" />
    </section>;
}